import { configureStore } from "@reduxjs/toolkit";
import structuralGroupReducer from "./slices/structuralGroupSlice"
import authReducer from "./slices/authSlice"
import blockingErrorReducer from "./slices/blockingErrorSlice"

export const store = configureStore({
    reducer: {
        structuralGroup: structuralGroupReducer,
        auth: authReducer,
        blockingError: blockingErrorReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['structuralGroup/setPositionsColumns'],
                ignoredPaths: ['structuralGroup.positionsColumns'],
            },
        }),
})